import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import Navigation from "../Navigation";
import { NewSourceFunctionBuilder } from "./NewSourceFunctionBuilder";
import { SourceFunctionDetailsView } from "./SourceFunctionDetailsView";
import { SourceFunctionsListView } from "./SourceFunctionsListView";
import { SourceFunction } from "./types";

const SourceFunctionsPage: React.FC = () => {
  const history = useHistory();
  const { sourceFunctionId: selectedSourceFunctionId } = useParams<{
    sourceFunctionId: string;
  }>();

  const { sourceFunctions, functionDefs } = useSelector(
    (state) => (state as any).functionDefs
  );

  if (selectedSourceFunctionId === "new") {
    return <NewSourceFunctionBuilder />;
  } else if (selectedSourceFunctionId) {
    const selectedSourceFunction = sourceFunctions.find(
      (sourceFunction: SourceFunction) =>
        sourceFunction.id === selectedSourceFunctionId
    );
    return (
      <SourceFunctionDetailsView
        selectedSourceFunction={selectedSourceFunction}
      />
    );
  } else {
    return (
      <SourceFunctionsListView
        onNewSource={() => {
          history.push("/source-functions/new");
        }}
        onSelectFunction={(id) => {
          history.push(`/source-functions/${id}`);
        }}
        functionDefs={functionDefs}
        sourceFunctions={sourceFunctions}
      />
    );
  }
};

export const SourceFunctionsPageWithNavigation = () => {
  return (
    <Navigation className="pt-6 h-full flex flex-col">
      <SourceFunctionsPage />
    </Navigation>
  );
};
